import * as HairProfileService from 'Services/HairProfileService';

import { fetchSomething } from 'utils/reduxUtils';

import { PRESCRIPTION_FAILURE, PRESCRIPTION_REQUEST, PRESCRIPTION_SUCCESS } from './actionTypes';

export const fetchPrescription = fetchSomething(
  [PRESCRIPTION_REQUEST, PRESCRIPTION_SUCCESS, PRESCRIPTION_FAILURE],
  () => HairProfileService.fetchPrescription()
);
